import * as React from "react";
import { NewAssignmentContext } from "src/providers/NewAssignment";

const useNewAssignment = () => {
  return React.useContext(NewAssignmentContext);
};

export default useNewAssignment;
